import React, { createContext, useContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { getAuthToken } from '../utils';

const AuthContext = createContext({
  sections: [],
  canView: () => false,
  refreshAuth: () => {},
});

const decodeToken = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
};

const buildValue = () => {
  const token = getAuthToken();
  if (!token) return { sections: [], canView: () => false };
  const payload = decodeToken(token);
  const sections = payload?.sections || [];
  return { sections, canView: (section) => sections.includes(section) };
};

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(buildValue);

  const refreshAuth = useCallback(() => {
    setAuth(buildValue());
  }, []);

  return (
    <AuthContext.Provider value={{ ...auth, refreshAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAuth = () => useContext(AuthContext);
